import { createStore } from 'vuex';
import VuexPersist from 'vuex-persist';
import vehicle from './modules/vehicle';
import quote from './modules/quote';
import guestLogin from './modules/guest';
import STEPS from '../assets/_steps';
import { OKAY, I_AM_A_TEAPOT, BAD_SERVER } from "./_commons";

// couldn't get vuex-persist to work by module so it is here in root
const vuexSessionStorage = new VuexPersist({
  key: 'ridmv',
  storage: window.sessionStorage,
  reducer: state => ({    // required for mapGetters and/or mapState, if using
    vehicle: {
      plateNumber: state.vehicle.plateNumber,
      registrationType: state.vehicle.registrationType,
      vinNumberLastSix: state.vehicle.vinNumberLastSix,
    },
    quote: {
      customerName: state.quote.customerName,
      gvwr: state.quote.gvwr,
      vehicleTypeId: state.quote.vehicleTypeId,
      vehiclePlateTypeId: state.quote.vehiclePlateTypeId,
    },
    guestLogin: {
      duration: state.guestLogin.duration,
      // accessToken: state.guestLogin.accessToken
    },
  }),
});

export default createStore({
  state: () => ({
    STATUSES: {
      SERVER_ERR: BAD_SERVER,
      SUCCESS: OKAY,
      TEAPOT: I_AM_A_TEAPOT,
    },
    STEPS: STEPS,
    // LANG: LANG_EN,

    isLoading: false,
    networkResponse: { status: OKAY, message: '' },
  }),

  mutations: {
    setState(state, data) {
      state[data.property] = data.value; 
    }
  },
  actions: {
    /**
     * Sets network status to 418 so that it won't be displayed when user navigates around web app.
     * Used by router. See also /utils/networkUtils.js.
     * Note: Should not be used for error 500 which is supposed to be persistent through all screens.
     * @param context
     */
    setTransitionalNetworkStatus({ commit }) {
      commit('setState', { property: 'networkResponse', value: { status: I_AM_A_TEAPOT, message: '' } });
    },
  },
  modules: {
    vehicle,
    quote,
    guestLogin,
  },
  plugins: [ vuexSessionStorage.plugin ]
})
